<script>
    export let items
</script>
<div class="w-full h-full overflow-y-scroll">
    <slot name="header"></slot>
    {#each items as item }
        <slot {item}>
            <div class="p-8 ">
                {JSON.stringify(item)}
            </div>
            <hr>
        </slot>
    {/each}    
    <slot name="footer"></slot>
    
</div>